import { createTheme } from '@mui/material';
import palette from '../palette';

const defaultTheme = createTheme();

const MuiButton = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      padding: '8px 16px',
      fontWeight: 500,
      transition: defaultTheme.transitions.create(['background-color', 'box-shadow', 'border', 'color'], {
        duration: defaultTheme.transitions.duration.short,
      }),
    },
    colorInherit: {
      background: palette.background.block,
    },
    sizeSmall: {
      padding: '0 16px',
      fontSize: '1rem',
      fontWeight: 400,
      height: '2.25rem',
    },
    sizeLarge: {
      minWidth: 64,
      minHeight: 48,
      padding: '14px 30px',
      fontSize: '1rem',
    },
    contained: {
      fontSize: '1rem',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    text: {
      padding: '10px 0 !important',
      '&:hover': {
        color: palette.primary.main,
        background: 'transparent',
      },
    },
    startIcon: {
      marginRight: '5px',
    },
    endIcon: {
      marginLeft: '5px',
    },
  },
};

export default MuiButton;
